import { Navigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { lookupProjects } from '../api/projects'

/**
 * Home redirector: if user has a project, route to its dashboard.
 * Else show empty-state to create one (P2 feature, basic placeholder for now).
 */
export default function Home() {
  const projectsQ = useQuery({
    queryKey: ['lookups', 'projects'],
    queryFn: lookupProjects,
    staleTime: 30_000,
  })

  if (projectsQ.isLoading) {
    return (
      <div className="flex min-h-full items-center justify-center">
        <div className="h-6 w-6 rounded-full border-2 border-border border-t-accent animate-spin" />
      </div>
    )
  }

  const projects = projectsQ.data ?? []
  if (projects.length > 0 && projects[0]) {
    return <Navigate to={`/projects/${projects[0].key}`} replace />
  }

  return (
    <div className="mx-auto max-w-2xl px-6 py-16 text-center">
      <h1 className="text-2xl font-semibold tracking-tight">Welcome to Atlas</h1>
      <p className="text-sm text-fg-subtle mt-2">
        Create your first project to get started.
      </p>
    </div>
  )
}
